import { render, staticRenderFns } from "./VehicleVariants.vue?vue&type=template&id=9266bb68&"
import script from "./VehicleVariants.vue?vue&type=script&lang=js&"
export * from "./VehicleVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports